module.exports = __webpack_public_path__ + "static/house_static-69aee464e6312079fb09308dc0f22a8f.png";